var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-form-group',{attrs:{"value":_vm.value.metric,"name":"metric","label":"Metric","error":(_vm.errors.metric || [])[0],"options":_vm.metricOptions},on:{"input":function($event){return _vm.input('metric', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }